import { Box } from "@mui/material";
import { socialsArray } from "../../utils/SliderData";
import SocialBox from "../Slider/SocialBox";

const SocialsMobile = () => {
    return (
        <Box sx={{
            backgroundColor: 'white',
            height: '23.75vw',
            display: 'flex', 
            flexDirection: 'row', 
        }}>
            {socialsArray.map((i,j) => (
                <SocialBox {...i} key={j} />
            ))}
        </Box>
    );

};

export default SocialsMobile;